import { enumIdentifierQualifier } from '@data-layer/enums/common';
import { enumFileExtension } from '@enum/enumFileExtension';
import { enumMimeType } from '@enum/enumMimeType';

// #13356 — the SS-4 is the IRS letter assigning an EIN, so it is only meaningful for companies
// registered by EIN. SSN and CBP-assigned (ANI) companies are never asked for it.
export const requiresSs4Document = (qualifier: enumIdentifierQualifier): boolean => qualifier === enumIdentifierQualifier.EIN;

// #13356 — the SS-4 is a PDF (scans are accepted too). The project-wide ALLOWED_FILE_* lists also carry
// Office formats, which must not pass as an SS-4, so this document keeps its own narrow whitelist.
export const SS4_FILE_EXTENSIONS: enumFileExtension[] = [
  enumFileExtension.PDF,
  enumFileExtension.JPG,
  enumFileExtension.JPEG,
  enumFileExtension.PNG,
  enumFileExtension.GIF,
];
export const SS4_FILE_MIMES: enumMimeType[] = [enumMimeType.PDF, enumMimeType.JPG, enumMimeType.JPEG, enumMimeType.PNG, enumMimeType.GIF];
